/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{noop as o}from"./noop.js";let e=o,r=o;"production"!==process.env.NODE_ENV&&(e=(o,e)=>{o||"undefined"==typeof console||console.warn(e)},r=(o,e)=>{if(!o)throw new Error(e)});export{r as invariant,e as warning};
//# sourceMappingURL=errors.js.map
